<ngb-toast *ngFor="let toast of allToast"
    [class]="toast.classname"
    [autohide]="true"
    [delay]="toast.delay || 500"
    (hidden)="remove(toast)">
        {{toast.textOrTpl }}
</ngb-toast>